import React, { useState } from 'react';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import DashboardNavBar from '../../components/dashboard/DashboardNavBar';
import VideoManager from '../../components/dashboard/VideoManager';

const { Content } = Layout;

const VideoManagerPage = () => {
  const location = useLocation();
  const { game } = location.state; // Access the passed game data

  // State to manage the collapsed state of the navbar
  const [collapsed, setCollapsed] = useState(false);

  const handleToggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* Dashboard Navbar */}
      <DashboardNavBar game={game} collapsed={collapsed} onToggle={handleToggleCollapsed} />

      {/* Content Area */}
      <Layout
        style={{
          marginLeft: collapsed ? '80px' : '250px', // Adjust dynamically based on the collapsed state
          transition: 'margin-left 0.2s', // Smooth transition for collapsing
          marginTop: '64px', // Offset for top nav bar height
          backgroundColor: '#fff', // Match content background
        }}
      >
        <Content style={{ padding: '20px' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            {/* Pass gameId to VideoManager */}
            <VideoManager gameId={game.id} />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default VideoManagerPage;
